import { SIGNALS_REST_API_CONFIGURED_QUERY_KEY } from "./const";

export const signalsRestApiQueryKeys = {
    getConfiguredStatus(): readonly [typeof SIGNALS_REST_API_CONFIGURED_QUERY_KEY] {
        return [SIGNALS_REST_API_CONFIGURED_QUERY_KEY];
    },
};
